import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { LogistikOrderReminder } from '../reminders.js';

const resolveSubscribeUnsentByOrderID = registerSubscription({
  operationName: 'subscribeUnsentLogistikOrderReminderByOrderID',
  type: () => [LogistikOrderReminder],
  params: [{ name: 'orderID', type: () => ID }],
  options: {},
  resolve:
    (orderID: string) =>
    <SelSet extends BaseQLSelectionSet<LogistikOrderReminder>>(gqlFields: SelSet) =>
      watchQuery<LogistikOrderReminder>(
        LogistikOrderReminder._collectionName,
        { orderID, isSent: { $ne: true } },
        { sort: { dueDate: 1 } },
      ),
});

export namespace LogistikOrderReminderAPI {
  export const subscribeUnsentByOrderID = resolveSubscribeUnsentByOrderID;
}
